import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

function FadeInWhenVisible({ children, variants, duration}) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      transition={{ duration }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
}
const LinksCard = ({ item, styles ,handleSocialMediaClick}) => {
  const baseUrl = process.env.REACT_APP_API_URL;

const [coloumValue, setColoumValue] = useState(JSON.parse(item?.coloum_value));
const [fonts, setFonts] = useState(null);
const [fontValue, setFontValue] = useState(null);
const [stylesColoumValue, setStylesColoumValue] = useState(null);
const [backgroundStyle, setBackgroundStyle] = useState({});
const [fontStyle, setFontStyle] = useState({});

const [linkStyles, setLinkStyles] = useState(styles?.find(item => item.coloum_name === "link"));

useEffect(() => {
  if (item?.coloum_value) {
    setColoumValue(JSON.parse(item.coloum_value));
  }
  if (styles) {
    const fontsStyle = styles?.find(item => item.coloum_name === "fonts");
    setFonts(fontsStyle || null);
  }
  if (fonts?.coloum_value) {
    setFontValue(JSON.parse(fonts?.coloum_value));
  }
  if (styles) {
    const linkStyles = styles?.find(item => item.coloum_name === "link");
    setLinkStyles(linkStyles || null);
  }
  if (linkStyles?.coloum_value) {
    setStylesColoumValue(JSON.parse(linkStyles?.coloum_value));
  }
}, [item, styles, fonts, linkStyles]);

useEffect(() => {
  const newBackgroundStyle = stylesColoumValue?.link_colors?.link_button_bg_color
    ? {
        background: stylesColoumValue.link_colors.link_button_bg_color,
      }
    : {};
  setBackgroundStyle(newBackgroundStyle);

  if (fontValue && linkStyles) {
    const newFontStyle = {
      color: stylesColoumValue?.link_colors?.link_button_font_color,
      fontFamily: fontValue.fontType.value,
    };
    setFontStyle(newFontStyle);
  } else if (fontValue) {
    const newFontStyle = {
      fontFamily: fontValue.fontType.value,
    };
    setFontStyle(newFontStyle);
  } else if (linkStyles) {
    const newFontStyle = {
      color: stylesColoumValue?.link_colors?.link_button_font_color,
    };
    setFontStyle(newFontStyle);
  } else {
    setFontStyle({});
  }
}, [fontValue, linkStyles, stylesColoumValue]);

const variants = {
  "none": {
    visible: { opacity: 1, scale: 1 },
    hidden: { opacity: 0, scale: 0 },
  },
  "fade-up": {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: -50 },
  },
  "fade-down": {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  },
  "fade-left": {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -50 },
  },
  "fade-right": {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: 50 },
  },
  "fade-up-right": {
    visible: { opacity: 1, x: 0, y: 0 },
    hidden: { opacity: 0, x: 50, y: -50 },
  },
  "fade-up-left": {
    visible: { opacity: 1, x: 0, y: 0 },
    hidden: { opacity: 0, x: -50, y: -50 },
  },
  "fade-down-right": {
    visible: { opacity: 1, x: 0, y: 0 },
    hidden: { opacity: 0, x: 50, y: 50 },
  },
  "fade-down-left": {
    visible: { opacity: 1, x: 0, y: 0 },
    hidden: { opacity: 0, x: -50, y: 50 },
  },
  "flip-up": {
    visible: { opacity: 1, rotateX: 0 },
    hidden: { opacity: 0, rotateX: -90 },
  },
  "flip-down": {
    visible: { opacity: 1, rotateX: 0 },
    hidden: { opacity: 0, rotateX: 90 },
  },
  "flip-left": {
    visible: { opacity: 1, rotateY: 0 },
    hidden: { opacity: 0, rotateY: -90 },
  },
  "flip-right": {
    visible: { opacity: 1, rotateY: 0 },
    hidden: { opacity: 0, rotateY: 90 },
  },
  "slide-up": {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  },
  "slide-down": {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: -50 },
  },
  "slide-left": {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: 50 },
  },
  "slide-right": {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -50 },
  },
  "zoom-in": {
    visible: { opacity: 1, scale: 1 },
    hidden: { opacity: 0, scale: 1.5 },
  },
  "zoom-in-up": {
    visible: { opacity: 1, scale: 1, y: 0 },
    hidden: { opacity: 0, scale: 1.5, y: -50 },
  },
  "zoom-in-down": {
    visible: { opacity: 1, scale: 1, y: 0 },
    hidden: { opacity: 0, scale: 1.5, y: 50 },
  },
  "zoom-in-left": {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: { opacity: 0, scale: 1.5, x: -50 },
  },
  "zoom-in-right": {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: { opacity: 0, scale: 1.5, x: 50 },
  },
  "zoom-out": {
    visible: { opacity: 1, scale: 1 },
    hidden: { opacity: 0, scale: 0.5 },
  },
  "zoom-out-up": {
    visible: { opacity: 1, scale: 1, y: 0 },
    hidden: { opacity: 0, scale: 0.5, y: -50 },
  },
  "zoom-out-down": {
    visible: { opacity: 1, scale: 1, y: 0 },
    hidden: { opacity: 0, scale: 0.5, y: 50 },
  },
  "zoom-out-left": {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: { opacity: 0, scale: 0.5, x: -50 },
  },
  "zoom-out-right": {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: { opacity: 0, scale: 0.5, x: 50 },
  },
};


const [animationType, setAnimationType] = useState(
  linkStyles?.coloum_value ? JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_type?.value || "none" : "none"
);

const [animationDuration, setAnimationDuration] = useState(
  linkStyles?.coloum_value ? JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_runs
    ? parseFloat(JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_runs.slice(0, -1))
    : 0 :0
);

useEffect(() => {
  setAnimationType(linkStyles?.coloum_value ? JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_type?.value || "none" : "none");
  setAnimationDuration(
    linkStyles?.coloum_value ? JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_type?.value === "none" ? 0 : JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_runs
      ? parseFloat(JSON.parse(linkStyles?.coloum_value)?.link_animation?.link_animation_runs.slice(0, -1))
      : 0 :0
  );
}, [stylesColoumValue, linkStyles]);

useEffect(() => {
  setAnimationType(stylesColoumValue?.link_animation?.link_animation_type?.value || "none");
  setAnimationDuration(
    stylesColoumValue?.link_animation?.link_animation_type?.value === "none" ? 0 : stylesColoumValue?.link_animation?.link_animation_runs
      ? parseFloat(stylesColoumValue?.link_animation?.link_animation_runs.slice(0, -1))
      : 0
  );
}, [styles, fontValue, linkStyles, stylesColoumValue]);


const handleClick = () => {
  // Parse the URL to get the column type
  const url = new URL(coloumValue?.coloum_value);
  let hostname = url.hostname.toLowerCase();
  
  // Prepend "www." if it's not already included
  if (!hostname.startsWith("www.")) {
    hostname = "www." + hostname;
  }
  let columnType = null;

  // Map the hostname to column types
  switch (hostname) {
    case "www.youtube.com":
      columnType = "YouTube"; // Corrected to "YouTube" instead of "Youtube"
      break;
    case "www.instagram.com":
      columnType = "Instagram";
      break;
    case "www.pinterest.com":
      columnType = "Pinterest";
      break;
    case "www.linkedin.com":
      columnType = "LinkedIn";
      break;
    case "www.twitter.com":
      columnType = "Twitter";
      break;
    case "www.facebook.com":
      columnType = "Facebook";
      break;
    default:
      // Set columnType to null for unknown hosts
      columnType = null;
      break;
  }

  // Call handleSocialMediaClick with the extracted column type
  handleSocialMediaClick(columnType);
};




  return (
    <>
     <div  id={item?._id} className="w-full">
     <FadeInWhenVisible variants={variants[animationType]} duration={animationDuration}>
      <a
        href={coloumValue?.coloum_value}
        target="_blank"
        rel="noopener noreferrer"
        className={`w-full  `}
        onClick={handleClick}
      >
        <div
          style={{
            ...backgroundStyle,
            borderStyle: stylesColoumValue?.link_outline?.link_outline_Style,
            borderColor: stylesColoumValue?.link_outline?.link_outline_colour,
          }}
          className={`w-full ${
            !stylesColoumValue?.link_colors?.link_button_bg_color
              ? "bg-white"
              : ""
          } ${
            stylesColoumValue?.link_shape
              ? stylesColoumValue?.link_shape === "rounded"
                ? "rounded-lg md:rounded-[12px]"
                : stylesColoumValue?.link_shape === "circle"
                ? "rounded-full"
                : "rounded-none"
              : "rounded-lg md:rounded-[12px]"
          } ${
            stylesColoumValue?.link_outline
              ? `${
                  stylesColoumValue?.link_outline?.link_outline_width ===
                  "8px"
                    ? "border-8"
                    : stylesColoumValue?.link_outline?.link_outline_width ===
                      "4px"
                    ? "border-4"
                    : stylesColoumValue?.link_outline?.link_outline_width ===
                      "2px"
                    ? "border-2"
                    : "border"
                } border-${
                  stylesColoumValue?.link_outline?.link_outline_Style
                } border-[${
                  stylesColoumValue?.link_outline?.link_outline_colour
                }]`
              : ""
          } p-[5px] flex items-center gap-[10px] md:gap-[16px] ${item?.linkIcon?"":"px-[15px] md:px-[21px]"}`}
        >
          {item?.linkIcon && <div>
            <img
                
              className={`max-h-[40px] min-h-[40px] h-[40px] max-w-[40px] min-w-[40px] w-[40px] md:max-h-[56px] md:min-h-[56px] md:h-[56px] md:max-w-[56px] md:min-w-[56px] md:w-[56px] object-cover ${
                stylesColoumValue?.link_shape
                  ? stylesColoumValue?.link_shape === "rounded"
                    ? "rounded-lg md:rounded-[10px]"
                    : stylesColoumValue?.link_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                  : "rounded-lg md:rounded-[10px]"
              } p-[1.5px]`}
              src={`${
                item?.linkIcon ? baseUrl + "/profile/" + item?.linkIcon : ""
              }`}
              alt="..."
              title="Icon"
            />
          </div>}
          <div className={`w-full flex justify-between ${item?.linkIcon?"":"py-[10px] md:py-[16px]"}`}>
            <p
              style={fontStyle}
              className={`text-small2 md:text-body_copy2 font-${
                fontValue?.fontType?.value
              } ${
                !stylesColoumValue?.link_colors?.link_button_font_color
                  ? "text-[#000000]"
                  : ``
              } capitalize`}
            >
              {item?.coloum_type}
            </p>
          </div>
        </div>
      </a>
      </FadeInWhenVisible>
    </div>
    </>
  );
};

export default LinksCard;
